export default function FinalCTA() {
  return (
    <section id="partnership" className="relative py-32 lg:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20business%20handshake%20partnership%20agreement%20modern%20office%20environment%20corporate%20collaboration%20trust%20and%20cooperation%20clean%20professional%20setting&width=1920&height=800&seq=partnership-cta-004&orientation=landscape"
          alt="Partnership"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-8 tracking-tight">
          INTERESTED IN PARTNERING
          <br />
          WITH AKTEN INC?
        </h2>
        <p className="text-lg lg:text-xl text-white/90 mb-6 max-w-3xl mx-auto">
          We carefully review all partnership requests and
        </p>
        <p className="text-lg lg:text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          respond to qualified suppliers.
        </p>

        <a
          href="/partnership"
          className="inline-flex items-center space-x-2 md:space-x-4 bg-akten text-white px-6 py-3 md:px-10 md:py-5 rounded-full text-sm md:text-lg font-semibold hover:bg-akten-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-akten-dark flex items-center justify-center">
            <i className="ri-hand-heart-line text-white text-lg md:text-xl"></i>
          </div>
          <span>PARTNER WITH US</span>
          <i className="ri-arrow-right-up-line text-xl md:text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
